/* eslint-disable camelcase */ 

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_build_your_routine_track_your_progress_meet_your_goals: Phrase =locale => {
  const en = `Build Your Routine, Track Your Progress, Meet Your Goals`;
  const phrases: { [key: string]: undefined | string } = {
    en, 
    es: `Crea tu rutina, sigue tu progreso, alcanza tus objetivos.`,
  };
  return phrases[locale] || en;
};
            